import React from 'react'
import { NavLink } from 'react-router-dom'
import icon from '../assets/iconlogo.svg'
import '../Component/css/Header2.css'

const Header2 = () => {
  return (
    <div id='header2'>
        <section className="header-img">
        <NavLink to='/'>
            <img src={icon} alt="" />
        </NavLink>
        </section>
        <section className="header-links">
            <NavLink to='/'>Portfolio</NavLink>
            <NavLink to='/About'>About</NavLink>
            <NavLink to='/Contact'>Contact</NavLink>
        </section>
    </div>
  )
}

export default Header2